"use strict";

exports.__esModule = true;
exports.default = void 0;

var _styledComponents = _interopRequireDefault(require("styled-components"));

var _propTypes = require("prop-types");

var _spacing = _interopRequireDefault(require("../../constants/spacing"));

var _breakpoints = _interopRequireDefault(require("../../constants/breakpoints"));

var _Button = _interopRequireDefault(require("../Button/Button"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _templateObject() {
  var data = _taggedTemplateLiteralLoose(["\n\tdisplay: flex;\n\tflex-direction: ", ";\n\tmargin-top: ", ";\n\n\t@media (min-width: ", ") {\n\t\tflex-direction: row;\n\t\tflex-wrap: wrap;\n\t}\n\n\t", ",\n\tbutton {\n\t\twidth: 100%;\n\t\tmargin-bottom: ", ";\n\n\t\t@media (min-width: ", ") {\n\t\t\twidth: auto;\n\t\t\tmargin-right: ", ";\n\t\t\tmargin-bottom: ", ";\n\n\t\t\t&:hover {\n\t\t\t\tmargin-right: ", ";\n\t\t\t}\n\t\t}\n\t}\n\n\t", ":last-child,\n\tbutton:last-child {\n\t\t@media (min-width: ", ") {\n\t\t\tmargin-right: 0;\n\t\t}\n\t}\n"]);

  _templateObject = function _templateObject() {
    return data;
  };

  return data;
}

function _taggedTemplateLiteralLoose(strings, raw) { if (!raw) { raw = strings.slice(0); } strings.raw = raw; return strings; }

var ButtonGroup = _styledComponents.default.div(_templateObject(), function (props) {
  return props.reverseColumnOrder ? 'column-reverse' : 'column';
}, _spacing.default.s2, _breakpoints.default.tablet, _Button.default, _spacing.default.s2, _breakpoints.default.tablet, _spacing.default.s1, _spacing.default.s1, _spacing.default.s1, _Button.default, _breakpoints.default.tablet);

ButtonGroup.propTypes = {
  reverseColumnOrder: _propTypes.bool
};
ButtonGroup.defaultProps = {
  reverseColumnOrder: false
};
ButtonGroup.displayName = 'ButtonGroup';
/** @component */

var _default = ButtonGroup;
exports.default = _default;